import React, { Component } from 'react';
import { Modal, Row, Col, Container, Button } from 'react-bootstrap';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";

const GETSCHEDULE_EXAMWISE_RESULTS = gql`
    query($schedule_exam_id:Int) {
        getScheduleExamWiseResults(schedule_exam_id:$schedule_exam_id){
            subject_id
            subject
            accuracy
            subject_score
            correct_qus
            correct_marks
        }
    }
`;

class ViewChapterWiseSummaryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const getScheduleExamWiseResults = this.props.getScheduleExamWiseResults;
        const loading1 = getScheduleExamWiseResults.loading;
        const error1 = getScheduleExamWiseResults.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (loading1) {
            return (
                <Container>
                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                </Container>
            )
        }

        const subjectPerformanceGraph = {
            chart: {
                type: "column",
                backgroundColor: "#f5f7fa",
                borderRadius: 10
            },

            title: {
                text: "",
                style: {
                    fontSize: "18px",
                    fontWeight: "600"
                }
            },

            xAxis: {
                categories:
                    getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                        s => s.subject
                    ) || [],
                title: {
                    text: "Subjects"
                },
                labels: {
                    style: {
                        fontWeight: "600"
                    }
                }
            },

            yAxis: [
                {
                    title: {
                        text: "Score / Marks"
                    }
                },
                {
                    title: {
                        text: "Accuracy (%)"
                    },
                    opposite: true,
                    max: 100
                }
            ],

            plotOptions: {
                series: {
                    borderRadius: 6,      // ✅ rounded columns
                    pointPadding: 0.15,
                    groupPadding: 0.2
                },
                column: {
                    dataLabels: {
                        enabled: true
                    }
                },
                line: {
                    dataLabels: {
                        enabled: getScheduleExamWiseResults?.getScheduleExamWiseResults?.length < 15
                    },
                    marker: {
                        enabled: true,
                        radius: 4
                    }
                }
            },

            series: [
                {
                    name: "Subject Score",
                    type: "column",
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number(s.subject_score || 0)
                        ) || [],
                    color: "#007bff"
                },

                {
                    name: "Correct Marks",
                    type: "column",
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number(s.correct_marks || 0)
                        ) || [],
                    color: "#28a745"
                },

                {
                    name: "Correct Questions",
                    type: "line",
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number(s.correct_qus || 0)
                        ) || [],
                    color: "#f39c12"
                },

                {
                    name: "Accuracy %",
                    type: "line",
                    yAxis: 1,
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number((s.accuracy * 100 || 0).toFixed(2))
                        ) || [],
                    color: "#e74c3c"
                }
            ],

            legend: {
                align: "center",
                verticalAlign: "bottom"
            },

            credits: {
                enabled: false
            },

            exporting: {
                enabled: true
            }
        };

        // const subjectPerformanceGraph = {
        //     chart: {
        //         type: "column",
        //         backgroundColor: "#f5f7fa",
        //         borderRadius: 10
        //     },

        //     title: {
        //         text: "Subject Wise Performance",
        //         style: {
        //             fontSize: "18px",
        //             fontWeight: "600"
        //         }
        //     },

        //     xAxis: {
        //         categories:
        //             getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
        //                 s => s.subject
        //             ) || [],
        //         title: {
        //             text: "Subjects"
        //         }
        //     },

        //     yAxis: [
        //         {
        //             title: {
        //                 text: "Score / Marks"
        //             }
        //         },
        //         {
        //             title: {
        //                 text: "Accuracy (%)"
        //             },
        //             opposite: true
        //         }
        //     ],

        //     // tooltip: {
        //     //     shared: true
        //     // },

        //     series: [
        //         {
        //             name: "Subject Score",
        //             type: "column",
        //             data:
        //                 getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
        //                     s => Number(s.subject_score)
        //                 ) || [],
        //             color: "#007bff"
        //         },

        //         {
        //             name: "Correct Marks",
        //             type: "column",
        //             data:
        //                 getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
        //                     s => Number(s.correct_marks)
        //                 ) || [],
        //             color: "#28a745"
        //         },

        //         {
        //             name: "Correct Questions",
        //             type: "line",
        //             data:
        //                 getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
        //                     s => Number(s.correct_qus)
        //                 ) || [],
        //             color: "#f39c12"
        //         },

        //         {
        //             name: "Accuracy %",
        //             type: "line",
        //             yAxis: 1,
        //             data:
        //                 getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
        //                     s => Number((s.accuracy * 100).toFixed(2))
        //                 ) || [],
        //             color: "#e74c3c"
        //         }
        //     ],

        //     plotOptions: {
        //         column: {
        //             borderRadius: 5,
        //             dataLabels: {
        //                 enabled: true
        //             }
        //         }
        //     },

        //     credits: {
        //         enabled: false
        //     },

        //     exporting: {
        //         enabled: true
        //     }
        // };

        return (
            <Modal {...this.props} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">{this.props.stateData[0]?.exam_name ?? ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{
                    width: '100%',
                    height: '550px',
                    overflow: 'auto',
                }}>
                    <Row>
                        <Col sm={12}>
                            {
                                getScheduleExamWiseResults.getScheduleExamWiseResults.length > 0 ? (
                                    <HighchartsReact
                                        Highcharts={Highcharts}
                                        options={subjectPerformanceGraph}
                                    />
                                ) : (
                                    <div className="text-center text-warning">
                                        Subjects data not available
                                    </div>
                                )
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}

export default withRouter(
    compose(
        graphql(GETSCHEDULE_EXAMWISE_RESULTS, {
            options: (props) => ({
                variables: {
                    schedule_exam_id: props.stateData?.[0]?.id
                },
                fetchPolicy: "network-only"
            }),
            name: "getScheduleExamWiseResults"
        })
    )(ViewChapterWiseSummaryModal)
);